import { gsap } from 'gsap';

export default class MainSlider {
  constructor(element) {
    this.element = element;
    this.interval = 3000;
    this.fadeInDuration = 1.2;
    this.fadeOutDuration = 1.2;
    this.fadeOutDelay = 0;
    this.scaleOutDelay = 0;
    this.zoomScale = 1.1;
    this.currentIndex = 0;
    this.timerId = null;
    this.tween = null;
    this.init();
  }

  init() {
    this.viewport = this.element.querySelector('.top-hero-slider__viewport') || this.element;
    this.slidesRoot = this.element.querySelector('.top-hero-slider__slides') || this.element;
    const slides = this.element.querySelectorAll('.top-hero-slider__slide');
    this.slides = Array.from(slides);
    this.images = this.slides.map(slide => slide.querySelector('img')).filter(Boolean);

    if (this.slides.length === 0 || this.images.length === 0) return;

    gsap.set(this.viewport, {
      position: 'relative',
      overflow: 'hidden',
    });

    gsap.set(this.slidesRoot, {
      position: 'relative',
      height: '100%',
    });

    gsap.set(this.slides, {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      zIndex: 0,
      pointerEvents: 'none',
    });

    gsap.set(this.images, {
      scale: 1,
      transformOrigin: 'center center',
    });

    gsap.set(this.slides[this.currentIndex], {
      opacity: 1,
      zIndex: 2,
    });

    this.scheduleNext();
  }

  scheduleNext() {
    this.clearTimer();
    if (this.slides.length <= 1) return;

    this.timerId = window.setTimeout(() => {
      this.goToNext();
    }, this.interval);
  }

  goToNext() {
    const previousIndex = this.currentIndex;
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    const previousSlide = this.slides[previousIndex];
    const previousImage = this.images[previousIndex];
    const nextSlide = this.slides[nextIndex];
    const nextImage = this.images[nextIndex];

    if (!previousSlide || !nextSlide) return;

    if (this.tween) {
      this.tween.kill();
    }

    // 次のスライドを初期状態にセット
    gsap.killTweensOf(nextImage);
    gsap.set(nextImage, { scale: 1 });
    gsap.set(nextSlide, {
      opacity: 0,
      zIndex: 3,
      pointerEvents: 'none',
    });
    gsap.set(previousSlide, {
      zIndex: 2,
      pointerEvents: 'none',
    });

    this.tween = gsap.timeline({
      onComplete: () => {
        this.currentIndex = nextIndex;
        this.slides.forEach((slide, index) => {
          const img = this.images[index];
          gsap.set(slide, {
            opacity: index === this.currentIndex ? 1 : 0,
            zIndex: index === this.currentIndex ? 2 : 0,
            pointerEvents: 'none',
          });
          if (img) {
            gsap.killTweensOf(img);
            gsap.set(img, { scale: 1 });
          }
        });
        this.scheduleNext();
      },
    });

    // スケール全体の尺 = fadeOutDelay + fadeOutDuration + scaleOutDelay
    const scaleDuration = this.fadeOutDelay + this.fadeOutDuration + this.scaleOutDelay;

    // 1) ズーム開始（タイムライン 0秒目から）
    if (previousImage) {
      this.tween.to(previousImage, {
        scale: this.zoomScale,
        duration: scaleDuration,
        ease: 'power1.out',
      }, 0);
    }

    // 2) 時間差でフェードアウト開始
    this.tween.to(previousSlide, {
      opacity: 0,
      duration: this.fadeOutDuration,
      ease: 'power1.out',
    }, this.fadeOutDelay);

    // 次のスライド: フェードアウト開始と同時にフェードイン
    this.tween.to(nextSlide, {
      opacity: 1,
      duration: this.fadeInDuration,
      ease: 'power2.out',
    }, this.fadeOutDelay);
  }

  clearTimer() {
    if (this.timerId) {
      window.clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  destroy() {
    this.clearTimer();
    if (this.tween) this.tween.kill();
    if (this.images) gsap.killTweensOf(this.images);
  }
}
